import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'AwarenessCenter/WizardCampaign/ReviewAndLaunchStep'

export const FETCH_TEST_CAMPAIGN_EMAILS_ASYNC = createAsyncTypes(
  'FETCH_TEST_CAMPAIGN_EMAILS',
  typeKey
)
export const FETCH_USER_EMAIL_ASYNC = createAsyncTypes('FETCH_USER_EMAIL', typeKey)

export const SEND_TRY_IT_OUT_ASYNC = createAsyncTypes('SEND_TRY_IT_OUT', typeKey)
export const SET_ERROR = `${typeKey}/SET_ERROR`
export const SET_TEST_CAMPAIGN_EMAILS_PAGE = `${typeKey}/SET_TEST_CAMPAIGN_EMAILS_PAGE`
export const CHANGE_TEST_CAMPAIGN_DATA = `${typeKey}/CHANGE_TEST_CAMPAIGN_DATA`
export const SET_USER_MAILBOX_ID = `${typeKey}/SET_USER_MAILBOX_ID`

export const EMAILS_PER_PAGE = 20
export const TRAINING_REMINDER_INDICES_ALL_VALUE = 'all'
